import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useLeagueStore } from '../lib/leagueStore';
import { isTslhTenant } from '../lib/tenantStore';
import { forceTslhLogout, TSLH_LEAGUE_ID } from '../lib/tenantSession';
import { useUserStore } from '../lib/userStore';

/**
 * Sécurité tenant TSLH : une session TSLH ne doit jamais utiliser une ligue
 * différente de 152 ni conserver un flag BPM hérité.
 */
export function TslhSessionGuard() {
  const navigate = useNavigate();
  const username = useUserStore((s) => s.username);
  const isTslhSession = useUserStore((s) => s.is_tslh_session);
  const currentLeagueId = useUserStore((s) => s.currentLeagueId);
  const isBpmSession = useUserStore((s) => s.is_bpm_session);
  const selectedLeague = useLeagueStore((s) => s.selectedLeague);

  useEffect(() => {
    if (!isTslhTenant() || !username) return;
    // Évite les faux positifs pendant l'auto-join (avant que is_tslh_session soit établi)
    if (!isTslhSession) return;

    const hasWrongSelectedLeague = !!selectedLeague?.id && selectedLeague.id !== TSLH_LEAGUE_ID;
    const hasWrongCurrentLeague = !!currentLeagueId && currentLeagueId !== TSLH_LEAGUE_ID;

    if (isBpmSession || hasWrongSelectedLeague || hasWrongCurrentLeague) {
      forceTslhLogout(
        navigate,
        'Session TSLH invalide. Reconnecte-toi avec un compte membre de la ligue TSLH.',
      );
    }
  }, [currentLeagueId, isBpmSession, isTslhSession, navigate, selectedLeague?.id, username]);

  return null;
}